/**
 * Action types
 */

export const TOGGLE_GLOBAL_TOAST = 'TOGGLE_GLOBAL_TOAST';
export const APP_LOADING = 'APP_LOADING';

export const UPDATE_USER_INFO = 'UPDATE_USER_INFO';

export const UPDATE_REGO_LIST = 'UPDATE_REGO_LIST';

export const UPDATE_NDIS_CATALOGUE = 'UPDATE_NDIS_CATALOGUE';

export const UPDATE_SUCCESSFUL_CLAIMS = 'UPDATE_SUCCESSFUL_CLAIMS';

export const UPDATE_BATCH_FILE = 'UPDATE_BATCH_FILE';

export const UPDATE_REMITTANCE = 'UPDATE_REMITTANCE';

export const UPDATE_FINANCIAL_CONTACT = 'UPDATE_FINANCIAL_CONTACT';

export const UPDATE_PRODUCT = 'UPDATE_PRODUCT';

export const UPDATE_NOTIFICATION_STATS = 'UPDATE_NOTIFICATION_STATS';

export const UPDATE_NOTIFICATIONS = 'UPDATE_NOTIFICATIONS';

export const UPDATE_CATEGORIES = 'UPDATE_CATEGORIES';

export const UPDATE_ORG_ID = 'UPDATE_ORG_ID';

export const UPDATE_DEFAULT_CONTACT_LIST = 'UPDATE_DEFAULT_CONTACT_LIST';

export const SET_LOADING_STATE = 'SET_LOADING_STATE';

export const UPDATE_LABELS = 'UPDATE_LABELS';

export const UPDATE_LEGAL_ENTITIES = 'UPDATE_LEGAL_ENTITIES';

export const UPDATE_PARTICIPANTS_LOOKUP = 'UPDATE_PARTICIPANTS_LOOKUP';

export const UPDATE_DELIVERY_SETTING = 'UPDATE_DELIVERY_SETTING';

export const SET_GENERAL_SETTING = 'SET_GENERAL_SETTING';

/* SUPPORT AT HOME */
export const UPDATE_SAH_PROVIDER_LIST = 'UPDATE_SAH_PROVIDER_LIST';
export const UPDATE_SAH_SERVICE_PROVIDERS = 'UPDATE_SAH_SERVICE_PROVIDERS';
export const UPDATE_SAH_SERVICE_CATALOGUE_PRICING = 'UPDATE_SAH_SERVICE_CATALOGUE_PRICING';
export const UPDATE_SAH_SERVICE_CATALOGUE = 'UPDATE_SAH_SERVICE_CATALOGUE';

export default {};
